import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';

var SvgBvt = function SvgBvt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 .053v12.614h17.895c.088 1.152.116 2.277.102 3.35a35.03 35.03 0 0 1-.114 3.316H14v12.614c-2.527-.112-4.937-.395-6.667-.86V19.332H.107a36.971 36.971 0 0 1-.104-3.35c-.014-1.055.02-2.17.114-3.316h7.216V.913C9.063.448 11.473.165 14 .053Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.667.129V14h19.305c.026.688.033 1.362.024 2.016.01.642 0 1.305-.03 1.984h-19.3v13.871c-1.445-.101-2.816-.262-4-.485V18H.03a38.365 38.365 0 0 1-.026-2.017c-.008-.641.001-1.304.03-1.983h8.634V.614C9.85.39 11.22.23 12.667.129Z",
    fill: "#227FBB"
  }));
};

export default SvgBvt;